/**
 * Classroom assessments API – all endpoints used by classroom assessments management.
 * Base path: /admin/classroom (classroom assessments routes mounted in backend organization routes).
 *
 * All endpoints return the standard shape:
 * - Success: { success: true, statusCode, message, data }
 * - Error: thrown with message from backend (response: { success: false, statusCode, message, error: { message } })
 * Use response.data for payload (e.g. response.data.assessments, response.data.pagination).
 */
import {
  GET,
  POST,
  PUT,
} from "../../apiController";

const CLASSROOM_ASSESSMENTS = '/admin/classroom';

// ==================== CLASSROOM ASSESSMENTS ====================

// Get all assessments for classroom
export const getAllAssessmentToClassroom = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessments/all`, data);
};

export const getClassroomAssessmentById = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment/details`, data);
};

// Add assessment to classroom
export const addAssessmentToClassroom = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment/add`, data);
};

// Remove assessment from classroom
export const removeAssessmentFromClassroom = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment`, data);
};

// Update assessment in classroom
export const updateAssessmentInClassroom = (data) => {
  return PUT(`${CLASSROOM_ASSESSMENTS}/assessment`, data);
};

// Copy assessment to another classroom
export const copyAssessment = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment/copy`, data);
};

// ==================== ASSESSMENT QUESTIONS ====================

// Add questions to assessment
export const addQuestionsToAssessment = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment/add_questions`, data);
};

// Get available questions for assessment
export const getQuestionsInAssessmentForAddModule = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment/available-questions`, data);
};

// Get all questions for classroom assessment
export const getAllQuestionsForClassroomAssessment = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment/questions/get`, data);
};

// Remove question from assessment
export const removeQuestionFromAssessment = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment/remove_question`, data);
};

// ==================== ASSESSMENT RESULTS ====================

// Get assessment results in classroom
export const getAssessmentResultsInClassroom = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment/trainee-results`, data);
};

// Get specific assessment result in classroom
export const getSpecificAssessmentResultInClassroom = (data) => {
  return POST(`${CLASSROOM_ASSESSMENTS}/assessment/trainee-result`, data);
};

// Get assessment analytics
export const getAssessmentAnalytics = (data) => {
  return GET(
    `${CLASSROOM_ASSESSMENTS}/${data.class_id}/assessment/${data.assessment_id}/analytics`
  );
};
